import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { NumberPicker } from './index';

const NumericPickerElement = forwardRef(function NumericPickerElement(props, ref) {
  return (
    <NumberPicker
      {...props}
      componentProps={{ ...props.componentProps, stringMode: true }}
      ref={ref}
    />
  );
});

NumericPickerElement.propTypes = {
  componentProps: PropTypes.shape({}),
};

export default NumericPickerElement;
